// Pure, bounded in-memory input recorder. No device or storage access.
function createState(){return {held:{},events:[],text:'',downs:0,repeats:0,mouse:0,sequence:0};}
function add(state,event){state.events.unshift({...event,id:++state.sequence});if(state.events.length>80)state.events.pop();}
function keyLabel(event){const mods=[];if(event.ctrlKey)mods.push('Ctrl');if(event.altKey)mods.push('Alt');if(event.shiftKey)mods.push('Shift');if(event.metaKey)mods.push('Win/Command');const names={Control:'Ctrl',Meta:'Win/Command',' ':'Space'};const k=names[event.key]||event.key||event.code||'Unidentified';if(!mods.includes(k))mods.push(k);return mods.join(' + ');}
function recordKey(state,event){
 const id=event.code||event.key,label=keyLabel(event),down=event.type==='keydown';
 const repeated=down&&(event.repeat||Object.prototype.hasOwnProperty.call(state.held,id));
 if(down){state.held={...state.held,[id]:label};if(repeated)state.repeats++;else state.downs++;}
 else {const held={...state.held};delete held[id];state.held=held;}
 add(state,{kind:down?(repeated?'repeat':'down'):'up',label,code:id,time:new Date().toLocaleTimeString(),location:event.location||0});
 if(down&&!event.ctrlKey&&!event.altKey&&!event.metaKey&&!event.isComposing){
  if(event.key==='Backspace')state.text=Array.from(state.text).slice(0,-1).join('');
  else if(event.key==='Enter')state.text+='\n';
  else if(event.key==='Tab')state.text+='\t';
  else if(event.key&&Array.from(event.key).length===1)state.text+=event.key;
  state.text=state.text.slice(-500);
 }
}
function recordMouse(state,event){
 const wheel=event.type==='wheel',id='Mouse'+event.button;
 if(!wheel){const held={...state.held};if(event.type==='mousedown')held[id]=id;else delete held[id];state.held=held;}
 state.mouse++;
 add(state,{kind:wheel?'wheel':event.type==='mousedown'?'down':'up',mouse:true,button:event.button,
  direction:wheel?(Math.abs(event.deltaY)>=Math.abs(event.deltaX)?event.deltaY<0?'upWheel':'downWheel':event.deltaX<0?'leftWheel':'rightWheel'):'',
  code:wheel?'ΔY '+event.deltaY+' / ΔX '+event.deltaX+' (mode '+event.deltaMode+')':id,time:new Date().toLocaleTimeString()});
}
export {createState,recordKey,recordMouse};



// WEBPACK FOOTER //
// ./src/stability/input-test.js